module.exports = __webpack_public_path__ + "img/come-vict-01.7b4467b2.jpg";